import React from "react";
import { api } from "@/utils/api";
import PdfFileItem from "@/react-components/PdfFileItem";
import { libraryTypeEnum } from "@/utils/enum";
import { isEmpty } from "@/utils";

class FinancialAnalysisHint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfInfos: undefined,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.library
      .getFinancialList()
      .then((res) => {
        this.setState({
          pdfInfos: res,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  getList = () => {
    const { pdfInfos } = this.state;
    const newList = [];
    if (pdfInfos?.length > 0) {
      pdfInfos.sort(
        (item1, item2) =>
          parseInt(item1.category.sortNo) - parseInt(item2.category.sortNo)
      );
      for (const pdfInfo of pdfInfos) {
        if (isEmpty(pdfInfo.category.categoryName)) {
          continue;
        }
        const find = newList.find(
          (item) => item.itemid === pdfInfo.category.itemid
        );
        if (find) {
          find.pdfList.push(pdfInfo);
          continue;
        }
        newList.push({
          itemid: pdfInfo.category.itemid,
          sortNo: pdfInfo.category.sortNo,
          infoTitle: pdfInfo.category.categoryName,
          pdfList: [pdfInfo],
        });
      }
    }

    return newList;
  };

  render() {
    const newList = this.getList();

    return (
      <div className="library-container">
        <div className="library-container-area library-container-col-area library-container-margin-top">
          {newList &&
            newList.length > 0 &&
            newList.map((item, index) => (
              <div
                id={item.itemid}
                key={index}
                className="library-container-margin-bottom"
              >
                <div className="library-container-info-title">
                  {item.infoTitle}
                </div>
                {item.pdfList &&
                  item.pdfList.length &&
                  item.pdfList.map((subitem, subindex) => (
                    <div key={subindex} className="library-info-area">
                      <div className="library-info-area-wrap">
                        <div className="library-row-area">
                          <PdfFileItem
                            pdfFile={
                              subitem.libraryType === libraryTypeEnum.pdf
                                ? subitem.pdfFile
                                : subitem.linkUrl
                            }
                            pdfTitle={subitem.title}
                            itemId={subitem.id}
                            libraryType={subitem.libraryType}
                            target={subitem.target}
                          >
                            <div className="library-row-area-item">
                              {subitem.libraryType === libraryTypeEnum.pdf && (
                                <img
                                  className="library-row-area-item-pdf"
                                  alt=""
                                  src={require("@/assets/images/icon_pdf.svg")}
                                />
                              )}
                              <span>{subitem.title}</span>
                              {subitem.libraryType === libraryTypeEnum.link && (
                                <img
                                  className="library-row-area-item-link"
                                  alt=""
                                  src={require("@/assets/images/icon-link.svg")}
                                />
                              )}
                            </div>
                          </PdfFileItem>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default FinancialAnalysisHint;
